export default __webpack_public_path__ + "static/media/game_1_l.adabb6b5.png";